import { useState } from "react";
import { useLocation } from "wouter";
import RenewalCalendar from "@/components/licenses/renewal-calendar";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/use-auth";

export default function Renewals() {
  const { user } = useAuth();
  const [, navigate] = useLocation();

  return (
    <div className="space-y-6 overflow-y-auto max-h-full">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">License Renewals Calendar</h1>
          <p className="text-sm text-muted-foreground mt-1">
            View and manage upcoming license renewals in a calendar format
          </p>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" onClick={() => navigate("/licenses")}>
            View All Licenses
          </Button>
        </div>
      </div>

      <div className="mt-6">
        <RenewalCalendar />
      </div>
    </div>
  );
}